<template>
  <div class="decl_number_wrap" v-click-outside="close">
    <span class="decl_number" v-if="order.ttn"><b>{{ order.ttn | asTTN }}</b></span>
    <span class="decl_number" v-else><b></b></span>
    <svg class="pencil open_drop" :class="{active:active_change}" data-id="decl_drop1" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" @click="active_change = !active_change">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.22065 1.33967C7.67354 0.886778 8.40782 0.886778 8.86071 1.33967C9.3136 1.79255 9.3136 2.52683 8.86071 2.97972L3.66721 8.17322L1.48047 8.71991L2.02715 6.53317L7.22065 1.33967Z" stroke="#ADB8C6" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <a
        v-if="order.delivery_id === 3 && order.media_files && order.media_files.length > 0"
        @click.stop
        target="_blank"
        :href="order.media_files[order.media_files.length - 1].link">&nbsp;
    <svg style="display: inline; margin-left: 5px" width="12" height="13" viewBox="0 0 12 13" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path d="M6.32472 0.701778C6.57345 0.439798 6.98453 0.431889 7.24288 0.684114C7.50123 0.936338 7.50903 1.35318 7.2603 1.61516L6.54181 2.37145C6.1048 2.83127 5.51215 3.45456 4.88962 4.10839C3.66359 5.39607 2.31601 6.80819 1.81756 7.31869C1.20153 8.08118 1.01372 9.51529 1.93375 10.4558C2.86343 11.4063 4.54605 11.4444 5.51304 10.4558C6.51816 9.42832 7.51489 8.37467 8.35864 7.4773C8.55514 7.2683 8.74385 7.06725 8.92266 6.87673C9.49971 6.26191 9.97381 5.75679 10.2751 5.44826C10.4349 5.26441 10.6306 4.93126 10.686 4.56266C10.7372 4.22262 10.6762 3.83258 10.2872 3.43496C9.88022 3.01889 9.50647 2.94982 9.21361 2.98115C8.89636 3.01509 8.61914 3.17571 8.47045 3.30687L3.74373 8.27696C3.72186 8.31221 3.69124 8.38056 3.6875 8.45711C3.68558 8.4965 3.69053 8.5389 3.70844 8.586C3.72632 8.63299 3.76309 8.70041 3.84339 8.7825C3.9029 8.84334 3.97376 8.86684 4.07745 8.85485C4.13242 8.8485 4.187 8.83203 4.23242 8.81104C4.27154 8.79295 4.28895 8.77886 4.28895 8.77886L7.55912 5.43584C7.81168 5.17766 8.22282 5.17597 8.47744 5.43207C8.73205 5.68818 8.73372 6.1051 8.48116 6.36328L5.20744 9.70994C4.97496 9.94759 4.60435 10.1194 4.22459 10.1633C3.81768 10.2104 3.32018 10.1177 2.92135 9.70994C2.51826 9.29787 2.36907 8.82782 2.39038 8.39192C2.4103 7.98444 2.57609 7.64847 2.7373 7.44247C2.75029 7.42588 2.76405 7.40993 2.77855 7.39469L7.55272 2.37471C7.56274 2.36417 7.57311 2.35398 7.5838 2.34414C7.89364 2.05907 8.42725 1.74103 9.07735 1.67148C9.76205 1.59823 10.525 1.80804 11.2093 2.50752C11.9115 3.22546 12.0778 4.04393 11.9699 4.76133C11.8673 5.44317 11.5237 6.01075 11.2305 6.34053C11.2236 6.34829 11.2165 6.35587 11.2093 6.36328C10.919 6.66 10.4541 7.15529 9.8727 7.77476L9.87243 7.77505C9.69181 7.96748 9.49995 8.17189 9.29859 8.38606C8.45337 9.28499 7.4495 10.3462 6.43508 11.3833C4.94678 12.9047 2.43599 12.8394 1.01169 11.3833C-0.496318 9.84161 -0.116372 7.60374 0.839418 6.45176C0.850832 6.438 0.862798 6.42472 0.875284 6.41196C1.34879 5.9279 2.70893 4.50272 3.95531 3.19367C4.57748 2.54021 5.16985 1.91723 5.60668 1.45759L6.32472 0.701778Z" fill="#ADB8C6"/>
    </svg>
    </a>
    <div class="menu_drop" data-id="decl_drop1" :class="{active:active_change}" :ref="'change_order_ttn' + order.id">
      <span class="close" @click="close"> </span>
      <div class="dropdown">
        <div class="change_decl_number ">
          <p v-if="order.ttn">Изменить номер декларации</p>
          <p v-else>Добавить номер декларации</p>
          <input type="text" v-model="ttn" v-mask="ttn_mask">
          <button class="btn" @click="updateTTN" v-if="order.ttn">Изменить</button>
          <button class="btn" @click="updateTTN" v-else>Добавить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { numbers } from '../../../helpers/numbers'
import { mapActions } from 'vuex'
import { mask } from 'vue-the-mask'
import { clickOutside } from '../../../helpers/clickOutside'
export default {
  name: 'OrderTtn',
  props: {
    order: Object
  },
  mixins: [
    numbers
  ],
  directives: {
    mask, clickOutside
  },
  data () {
    return {
      ttn: this.order.ttn,
      active_change: false,
      ttn_mask: '## #### #### ####'
    }
  },
  methods: {
    ...mapActions('orders', ['updateOrderTTN']),
    updateTTN () {
      const ttn = this.ttn.trim()
      this.updateOrderTTN([this.order.id, ttn])
      this.close()
    },
    close () {
      this.active_change = false
    }
  }
}
</script>

<style scoped lang="scss">
  .close {
    position: absolute;
    right: 7px;
    top: 6px;
    z-index: 10;
  }
</style>
